<div class="container-fluid tp-box vd-host" [@flipState]="flip">
	<div class="row tp-box__side tp-box__back" *ngIf="flip == 'active'">
		<div class="cw-wrap vd-wrap" [ngStyle]="themeVars">
			<div class="cw-icon-badge pointer" (click)="toggleFlip(false, '')" title="Back">
				<i class="material-icons">receipt_long</i>
			</div>
			<div class="cw-header">
				<div class="cw-title-group">
					<span class="cw-title">Ready To Invoice {{ title }}</span>
				</div>
				<div class="vd-toolbar">
					<button class="btn btn-success btn-sm" (click)="exportXls()" [disabled]="exporting || !viewing || viewing.length === 0">
						<i class="fa fa-file-excel-o"></i>
					</button>
					<button class="btn btn-danger btn-sm" (click)="exportPdf()" [disabled]="exporting || !viewing || viewing.length === 0">
						<i class="fa fa-file-pdf-o"></i>
					</button>
				</div>
			</div>
			<div class="cw-body" *ngIf="viewing">
				<div class="table" #print_table>
					<table class="table">
						<tr>
							<th>GRN Batch</th>
							<th>Date</th>
							<th>GRN#</th>
							<th>Order#</th>
							<th>Item</th>
							<th>Desc</th>
							<th>Rec</th>
							<th>Invoice</th>
							<th>PO Actions</th>
						</tr>
						<tr *ngFor="let v of viewing">
							<td>{{ v.grnbatch }}</td>
							<td>{{ v.deliverydate }}</td>
							<td>{{ v.grnno }}</td>
							<td>{{ v.orderno }}</td>
							<td>{{ v.itemcode }}</td>
							<td>{{ v.itemdescription }}</td>
							<td>{{ v.qtyrecd }}</td>
							<td>{{ v.quantityinv }}</td>
							<td>
								<button mat-icon-button (click)="navigateToPO(v.orderno)" matTooltip="Edit Purchase Order" *ngIf="v.orderno">
									<mat-icon>edit</mat-icon>
								</button>
							</td>
						</tr>
					</table>
				</div>
			</div>
		</div>
	</div>
	<div class="row tp-box__side tp-box__front" id="frontside" [ngClass]="flip == 'inactive' ? '' : 'd-none'">
		<div class="col-12 p-0">
			<app-dashboard-stat-card
				title="Ready To Invoice"
				icon="receipt_long"
				accent="success"
				[value]="invoiceLoaded ? invoice.length : null"
				[loading]="!invoiceLoaded"
				[showView]="invoiceLoaded"
				(view)="toggleFlip(invoice, 'All')">
			</app-dashboard-stat-card>
		</div>
	</div>
</div>
